
<style scoped lang="sass">
.drawer
  margin-bottom: 10px

  &:last-child
    margin-bottom: 0

.popup_combo_collapse_box
  position: relative

  .wrong_msg
    z-index: 1
    position: absolute
    top: 26px
    font-size: 10px
    line-height: 20px
    color: red
    left: 16px
    background: #f3f3f5
    padding-right: 10px

::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour) !important

  .van-stepper--round .van-stepper__plus
    background-color: var(--menu-primary-background-colour) !important

  .van-stepper--round .van-stepper__minus
    border-color: var(--menu-primary-background-colour) !important
    background-color: var(--menu-primary-background-colour) !important

  .van-button--primary
    background-color: var(--menu-primary-background-colour) !important

  .van-checkbox__label
    height: 100%
    margin-left: 0

  .van-checkbox__icon
    display: flex
    justify-content: center
    align-items: center
    height: 100%

  .material-icons
    padding: 18px 15px 18px 18px

.item
  display: flex
  justify-content: space-between
  align-items: center
  padding-right: 15PX
  height: 100%

  .name
    font-size: 14px
    color: var(--menu-primary-text-colour)

  .adjustMoney
    color: var(--menu-primary-text-colour)
    font-size: 14px

::v-deep
  .van-checkbox__label
    flex: 1

.recommand_product
  display: flex
  justify-content: space-between
  align-items: cneter
  height: 80px
  padding: 9px 0

  ::v-deep
    .material-icons
      color: var(--menu-primary-background-colour)

.recommand_product_img
  height: 100%
  margin-right: 9px
  border-radius: 5px

.dish_info
  flex: 1
  display: flex
  flex-direction: column

.dish_info_name
  margin-bottom: 12px
  line-height: 16px
  font-size: 14px
  color: var(--menu-primary-text-colour)

.dish_info_price
  line-height: 16px
  font-size: 14px
  color: var(--menu-primary-text-colour)

.option_number_controls
  display: flex
  align-items: center
  margin-left: 10px

  .number_display
    min-width: 24px
    text-align: center
    font-size: 12px
    font-weight: 500
    color: var(--menu-primary-text-colour)

  .number_btn
    display: flex
    align-items: center
    justify-content: center
    width: 24px
    height: 24px
    border-radius: 50%
    cursor: pointer
    transition: background-color 0.2s

    &.minus_btn
      background-color: #f44
      color: #fff

      &:hover
        background-color: #c00

      .btn_icon
        width: 10px
        height: 2px
        background-color: #fff
        border-radius: 1px

    &.plus_btn
      background-color: var(--menu-primary-background-colour)
      color: #fff

      &:hover
        opacity: 0.8

      .btn_icon
        position: relative
        width: 10px
        height: 2px
        background-color: #fff
        border-radius: 1px

        &::after
          content: ''
          position: absolute
          top: -4px
          left: 4px
          width: 2px
          height: 10px
          background-color: #fff
          border-radius: 1px

    &.disabled
      opacity: 0.4
      cursor: not-allowed

.item_with_number
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%

  .item_content
    flex: 1
    display: flex
    justify-content: space-between
    align-items: center
</style>

<template lang="pug">
div
  .popup_combo_collapse_box.drawer(
    v-for="(each, index) in modifications"
    :key="each.id + index"
  )
    .wrong_msg(v-if="each.wrong") {{ each.wrong }}
    collapse(
      v-if="each.options.some(item => !item.unShow)"
      :title="getLocalizedModName(each)"
      :desc="getDesc(each)"
      :name="index"
      :index="index"
      :id="parseInt(each.id)"
      :open="isSectionOpen(each)"
      :lock-open="isSectionLocked(each)"
    )
      van-checkbox(
        v-for="(item, chooseIndex) in each.options"
        :key="chooseIndex"
        v-if="isSinglePickSection(each) && !item.unShow"
        :name="item.name"
        :value="item.checked"
        :disabled="item.disabled"
        :label-disabled="true"
        @click="getCheckNum(index, chooseIndex)"
        @input="handleCheckBoxChoosed($event, item, each, chooseIndex, index)"
      )
        .item(v-if="each.id !== -1")
          .name {{ getLocalizedOptName(item) }}
          .adjustMoney(v-if="parseFloat(item.adjustPrice)")
            span.mark(v-if="symbolPosition !== 'after'") {{ each.removeType ? '-' : '+' }}{{ currencySymbol }}
            span.mark(v-else) {{ each.removeType ? '-' : '+' }}
            span.just_price {{ displayAbsPrice(item.adjustPrice) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .recommand_product(v-else @click="handleCheckBoxChoosed($event, item, each, chooseIndex, index)")
          slot(name="recommand-product" :each="each" :item="item" :chooseIndex="chooseIndex" :index="index")
        template(#icon="props")
          icon(v-if="props.checked && each.type === 'required'" :color="primaryColor") radio_button_checked
          icon(v-if="!props.checked && each.type === 'required'" :color="primaryColor") radio_button_unchecked
          icon(v-if="props.checked && each.type !== 'required'" :color="primaryColor") check_box
          icon(v-if="!props.checked && each.type !== 'required'" :color="primaryColor") check_box_outline_blank

      van-checkbox(
        v-for="(item, chooseIndex) in each.options"
        :key="item.id"
        :name="item.name"
        :value="item.checked"
        v-if="!isSinglePickSection(each) && !item.unShow"
        :disabled="item.disabled"
        :label-disabled="true"
        @click="handleOptionClick(index, chooseIndex, each, item)"
        @input="handleMultiCheckBoxInput($event, item, each, chooseIndex, index)"
      )
        .item_with_number
          .item_content
            .name {{ getLocalizedOptName(item) }}
            .adjustMoney(v-if="parseFloat(item.adjustPrice)")
              span.mark(v-if="symbolPosition !== 'after'") {{ each.removeType ? '-' : '+' }}{{ currencySymbol }}
              span.mark(v-else) {{ each.removeType ? '-' : '+' }}
              span.just_price {{ displayAbsPrice(item.adjustPrice) }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
          .option_number_controls(v-if="item.checked && !isRadioSelect(each)")
            .number_btn.minus_btn(@click.stop="decreaseNumber(index, chooseIndex, each, item)")
              .btn_icon
            .number_display {{ getOptionDisplayNumber(item) }}
            .number_btn.plus_btn(:class="{ disabled: !canIncrease(item, each) }" @click.stop="increaseNumber(index, chooseIndex, each, item)")
              .btn_icon
        template(#icon="props")
          icon(v-if="props.checked" :color="item.disabled ? blank : primaryColor") check_box
          icon(v-else :color="item.disabled ? blank : primaryColor") check_box_outline_blank
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import Collapse from 'components/Collapse'
import { getLocalizedModificationName, getLocalizedOptionName, t, tParams } from '@/utils/language'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition } from '@/utils/currency'
import {
  calcSelectedTotal,
  canIncreaseOption,
  decreaseOptionNumber,
  getOptionDisplayNumber as getOptionDisplayNumberFn,
  increaseOptionNumber,
  isRadioSelect as isRadioSelectFn
} from '../../utils/modOptionNumber'
import {
  applySingleSelectExclusive,
  isSectionLocked as isModSectionLocked,
  isSectionOpen as isModSectionOpen,
  sectionIsSingleSelect,
  sectionLimitKind,
  sectionLowerBound,
  sectionMaxOption
} from '../../utils/modSectionState'
import { limitWrongCopy, rangeWrongCopy, sectionPickDesc } from '../../utils/sectionDesc'

@Component({
  filters: {
    fix (val) {
      return formatDecimalNumber(val)
    }
  },

  props: {
    modifications: Array,
    passList: Array,
  },

  components: {
    Collapse
  },

  computed: {
    primaryColor() {
      return this.$store.state.app.color.menu_primary_background_colour
    },

    unPassIndexList() {
      return this.requiredIndexList.filter(key => !this.passList.includes(key))
    },

    modificationDescSettings() {
      return this.$store.state.modificationDescSettings
    },

    // Track currentLanguage to force re-render on language change
    // 跟踪 currentLanguage 以在语言切换时强制重新渲染
    currentLanguage() {
      return this.$store.state.language?.currentLanguage || 'en'
    },

    // Track currentCurrency to force re-render on currency change
    // 跟踪 currentCurrency 以在货币切换时强制重新渲染
    currentCurrency() {
      return this.$store.state.currencySettings?.currentCurrency || 'AUD'
    },

    currencySymbol() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    symbolPosition() {
      const _c = this.$currencyCode // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    }
  }
})

class CollapseBox extends Vue {
  modificationList = []
  recommandProductList = []
  blank = ''
  requiredIndexList = []

  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  tParams(key, fallback, params) { return tParams(key, fallback, params) }

  // Get localized modification group name / 获取本地化的修改组名称
  getLocalizedModName(modification) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedModificationName(modification) || modification.name
  }

  // Get localized option name / 获取本地化的选项名称
  getLocalizedOptName(option) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedOptionName(option) || option.name
  }

  // Convert and format absolute price value for display / 转换并格式化绝对价格值用于显示
  displayAbsPrice(price) {
    const _currency = this.currentCurrency // eslint-disable-line no-unused-vars
    const val = parseFloat(price) || 0
    return formatDecimalNumber(convertPrice(val < 0 ? -val : val))
  }

  getDesc(item) {
    // Reference currentLanguage to ensure Vue reactivity on language change
    // 引用 currentLanguage 以确保语言切换时 Vue 的响应式更新
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    // 「这一组要选几样」这句话里的数字，与换选 / 置灰 / 数量步进 / 单选渲染 /
    // 预勾选截断问的是同一个问题，所以三处 getDesc 共用 sectionPickDesc（见 utils/sectionDesc）。
    // 别在这里退回裸 maxOption，也别就地补一个回退三元式 —— 那就是分叉的来源。
    const firstName = sectionPickDesc(item, this.modificationDescSettings?.rangeDesc)
    // 可选组不带任何「必选」标记：念得出就念，念不出就一个字都不念。
    if (item.type !== 'required') return firstName
    // 必选组：「必选」这个信息**一定要说出去**，顾客不知道这组必填，
    // 比看到一个难看的括号严重得多（owner 2026-08-10 裁定，两仓统一）。
    // 但没有句子可挂的时候，一个前面带空格的「 (Required)」就是个残句 ——
    // 组名底下挂一对括号，既没说要选几样，也不像是句话。
    // 所以：没句子就**单独念那个词本身**，不带括号、不带前导空格。
    // 走到这里的只有「必选 limit 组没配上限」和没写 limitType 的组 ——
    // `range` 与必选的 `exactly` 组永远念得出数（见 utils/sectionDesc）。
    if (!firstName) return t('required', 'Required')
    // 有句子时后缀整句从语言包取，**不在代码里拼括号**：中文包的 `*_required`
    // 那几句用的是全角（必选）、无空格，而代码拼出来的是半角空格 + 半角括号 ——
    // 同一个必选组的组头与红字于是念两种标点（英文/法文对得上，只有中文不对）。
    // 空格也在语言包里：它是句子的一部分，不是排版。
    return firstName + t('required_suffix', ' (Required)')
  }

  // Each click
  // 每次点击
  getCheckNum(index, chooseIndex) {
    this.modifications.forEach((e, i, a) => {
      if (i === index) {
        // `limitType` 归一化成 range / limit / exactly 三选一（见 utils/sectionLimit 的
        // `sectionLimitKind`）：**认不出来的值一律当 `exactly`**（owner 2026-08-10 裁定）。
        // 以前这条链直接比裸 `limitType`，没有 `else` —— 没写 limitType 的必选组
        // 一条校验都不跑，一样都不选照样加进购物车，屏幕上却写着「Required」。
        const limitKind = sectionLimitKind(e)
        const minOption = e.minOption
        const chooseList = []
        const list = []
        // 这组一次最多能选几样：唯一定义在 utils/sectionLimit.js（null = 没配上限）
        const sectionLimit = sectionMaxOption(e)
        // Filter out the selected and unselected, and add them to different arrays
        // 筛选出已选和未选的选项，分别添加到不同的数组
        e.options.forEach((each, Index, array) => {
          list.push(Index)
          if (each.checked) {
            chooseList.push(Index)
            each.disabled = false
            // 初始化 number 字段
            if (!each.number || each.number <= 0) {
              each.number = 1
            }
            const noChooseIndexList = list.filter(function(v) { return chooseList.indexOf(v) === -1 })
            noChooseIndexList.forEach((eleIndex) => {
              e.options[eleIndex].disabled = false
            })
          }
        })

        // 使用 calcSelectedTotal 计算选中的总数量（考虑 number 字段）
        let selectedNum = calcSelectedTotal(e.options)

        // For single choice control, you can click to switch and select other options to obtain the selected quantity
        // 单选的控制，可以点击切换选中其他选项，获取已选择的数量
        if (sectionIsSingleSelect(e) && e.type === 'required') {
          const noChooseIndexList = list.filter(item => item !== chooseIndex)
          e.options[chooseIndex].checked = true
          e.options[chooseIndex].number = 1
          noChooseIndexList.forEach((eleIndex) => {
            e.options[eleIndex].checked = false
            e.options[eleIndex].number = 0
          })
          selectedNum = calcSelectedTotal(e.options)
        } else if (sectionIsSingleSelect(e)) {
          // 可选的单选组：点另一个直接换选，其余选项不灰（与主商品页同口径）
          // An optional single-pick section: swapping is one tap, nothing greys out.
          applySingleSelectExclusive(e, chooseIndex)
          selectedNum = calcSelectedTotal(e.options)
        } else {
          // Disable other options when multiple selections reach the maximum value required by the selection
          // 多选到达选中要求的最大值时，禁用其他选项（没配上限就一个都不灰）
          if (sectionLimit !== null && selectedNum >= sectionLimit) {
            const noChooseIndexList = list.filter(function(v) { return chooseList.indexOf(v) === -1 })
            noChooseIndexList.forEach((eleIndex) => {
              e.options[eleIndex].disabled = true
            })
          } else {
            const noChooseIndexList = list.filter(function(v) { return chooseList.indexOf(v) === -1 })
            noChooseIndexList.forEach((eleIndex) => {
              e.options[eleIndex].disabled = false
            })
          }
        }

        // The following are error message codes
        // 以下是关于错误信息代码
        if (e.type === 'required') {
          // console.log(selectedNum)
          if (limitKind === 'exactly') {
            // 「恰好选 N 样」的 N 就是这一组的有效上限（见 utils/sectionLimit.js：
            // min 为主、其次 max、必选组都说不出就兜底 1）。这一支在
            // `e.type === 'required'` 里，所以 sectionLimit 一定是个正整数
            // （可选的 exactly 组是 NO_CAP，但可选组不走校验）。校验侧必须问同一个函数 ——
            // 以前这里读裸 `parseInt(minOption)`，两个键都没写出数的组就拿 NaN 去比，
            // NaN 与任何数都不相等，于是这一组永远判红、商品永远加不进购物车。
            if (selectedNum !== sectionLimit) {
              this.wrongMsg = `Type：exactly ${e.name}'s number must be ${sectionLimit}`
              // console.log(this.wrongMsg)
              // If you want to change from checking the correctness after clicking the selection box, comment on the following code
              // 如果想换成不是点击选择框后就验证正确性，就注释下行代码
              e.wrong = tParams('select_n_required', 'Select {n} (Required)', { n: sectionLimit })
              this.pass = false
              const i = this.passList.indexOf(index)
              // If not, remove the data from passList
              // 若不通过，将该条数据从 passList 中移除
              if (i !== -1) {
                this.passList.splice(i, 1)
              }
            } else {
              // console.log(`${e.name}'s number is right`)
              this.pass = true
              e.wrong = false
              // console.log(e.wrong)
              if (this.passList.indexOf(index) === -1) {
                this.passList.push(index)
              }
            }
          } else if (limitKind === 'range') {
            // 下限走契约（utils/sectionLimit 的 sectionLowerBound）—— 红字念的那个数
            // 和这里拦人的这个数是同一个函数算出来的，不是两处各写一遍 `parseInt`
            // 碰巧一致。这一支在 `e.type === 'required'` 里，所以拿到的**一定**是个
            // >= 1 的整数：必选组的地板是 1，后台没配 `minOption` 也一样
            // （owner 2026-08-10：「必选组不存在连 1 个都不选就能过去的」）。
            // 以前这里读的是裸 `lowerBound`，说不出数就 `minNum !== null` 整条短路 ——
            // 勾一下再取消，这组就带着 0 个选择进了 passList，加购时不再判红。
            const minNum = sectionLowerBound(e)
            if (parseInt(selectedNum) < minNum) {
              this.wrongMsg = `Type：range ${e.name}'s MinOption is ${minOption}`
              // console.log(this.wrongMsg)
              this.pass = false
              // 念的两个数各自要「念得出」才念（见 utils/sectionDesc 的 rangeCopy）：
              // 原值直出会念成 `Select between 2 and 0` / `Select between 2.5 and 3`，
              // 而校验卡的是 parseInt 之后的下限、置灰卡的是有效上限。
              e.wrong = rangeWrongCopy(e)

              const i = this.passList.indexOf(index)
              if (i !== -1) {
                this.passList.splice(i, 1)
              }
            } else {
              // console.log(` Type range : ${e.name} is right`)
              this.pass = true
              e.wrong = false
              if (this.passList.indexOf(index) === -1) {
                this.passList.push(index)
              }
            }
          } else if (limitKind === 'limit') {
            if (parseInt(selectedNum) < 1) {
              this.pass = false
              // 这一支拦的是「一样都没选」（就是上一行那个 < 1），所以念「至少选 1 样」。
              // 以前念的是 `Select up to {minOption}`，而 `limit` 组的 minOption 通常是
              // 0 或空 —— 屏上成了「最多选择 0 项（必选）」/ `Select up to  (Required)`。
              e.wrong = limitWrongCopy()
              const i = this.passList.indexOf(index)
              if (i !== -1) {
                this.passList.splice(i, 1)
              }
            } else {
              this.pass = true
              e.wrong = false
              if (this.passList.indexOf(index) === -1) {
                this.passList.push(index)
              }
            }
          }
        }

        this.$forceUpdate()
      }
    })
  }

  /**
   * Functions executed after the option is changed
   * value: Variables bound by the box
   * eachOption: Corresponding modifications
  */
  /**
   * 选项发生改变后，执行的函数
   * value: 选框绑定的变量
   * eachOption: 对应的配菜选项
  */
  /**
   * 多选配菜的 @input 处理（非单选组的 van-checkbox，见 isSinglePickSection）
   * Handler for multi-select checkbox @input event.
   */
  handleMultiCheckBoxInput(value, eachOption, each, chooseIndex, index) {
    if (eachOption.disabled) return

    // 标记当前事件周期中有 @input 触发
    // Mark that @input was triggered in this event cycle
    this._inputFiredForOption = `${index}_${chooseIndex}`

    eachOption.checked = !eachOption.checked

    // 如果刚被勾选，初始化 number 为 1
    if (eachOption.checked && (!eachOption.number || eachOption.number <= 0)) {
      eachOption.number = 1
    }
    // 如果取消勾选，重置 number 为 0
    if (!eachOption.checked) {
      eachOption.number = 0
    }

    this.getCheckNum(index, chooseIndex)
    this.$forceUpdate()
  }

  handleCheckBoxChoosed(value, eachOption, each, chooseIndex, index) {
    eachOption.checked = !eachOption.checked
    this.$forceUpdate()
  }

  _validateRequiredModifications() {
    // Form validation. If there is an option that fails, the corresponding prompt text will be displayed and the first error will be jumped to
    // 表单验证，若有没通过的选项，显示对应提示文字，并跳转到第一个错误
    this.modifications = this.modifications.map((item, index) => {
      if (item.type === 'required' && !this.passList.includes(index)) {
        // `limitType` 归一化成 range / limit / exactly 三选一（见 utils/sectionLimit 的
        // `sectionLimitKind`）：**认不出来的值一律当 `exactly`**（owner 2026-08-10 裁定）。
        // 以前这条链直接比裸 `limitType`，没有 `else` —— 没写 limitType 的必选组
        // 一条校验都不跑，一样都不选照样加进购物车，屏幕上却写着「Required」。
        const limitKind = sectionLimitKind(item)
        let wrongMsg
        if (!item.options.every(option => option.unShow)) {
          if (limitKind === 'exactly') {
            // 念的是这一组真正被校验的那个数（有效上限，见 utils/sectionLimit.js），
            // 不是裸 minOption —— 两个键都没写出数时裸值会念成 `Select  (Required)`。
            // 这一支在 `item.type === 'required'` 里，所以有效上限一定是个正整数
            // （可选的 exactly 组是 NO_CAP，但它不做校验，也就没有这句提示）。
            wrongMsg = tParams('select_n_required', 'Select {n} (Required)', { n: sectionMaxOption(item) })
          } else if (limitKind === 'range') {
            // 两个数各自要「念得出」才念，唯一实现见 utils/sectionDesc 的 rangeCopy
            wrongMsg = rangeWrongCopy(item)
          } else if (limitKind === 'limit') {
            // 这一组的校验拦的是「一样都没选」，所以念「至少选 1 样」——
            // 以前念 `Select up to {minOption}`，而那个字段在 limit 组通常是 0 或空
            wrongMsg = limitWrongCopy()
          }
        }
        return {
          ...item,
          wrong: wrongMsg
        }
      } else {
        return item
      }
    })
    return this.modifications.filter(item => item.wrong && !item.options.every(option => option.unShow)).length === 0
  }

  // Get the required modificartion subscript to facilitate the form verification and judgment
  // 获取必选的配菜下标，方便表单验证判断
  _getProductRequiredModificationsIndex() {
    this.modifications.forEach((item, index) => {
      if (item.type === 'required') {
        this.requiredIndexList.push(index)
      }
    })
  }

  // Scroll to the first form error position
  // 滚动到第一个表单错误位置
  _scrollToErrorItem() {
    // Get the offsetTop value of the index of the first unpassList
    // 获取第一个 unpassList 的 index 的 offsetTop 值
    const targetIndex = this.unPassIndexList[0]
    const targetDom = document.getElementsByClassName('popup_combo_collapse_box')[targetIndex]
    targetDom.scrollIntoView({ behavior: 'smooth' })
  }

  // Selected by default
  // 默认选中
  _defaultChoose() {
    if (!this.modifications) return
    this.modifications.forEach((each, index) => {
      each.options.forEach((item, chooseIndex) => {
        if (item.checked) this.getCheckNum(index, chooseIndex)
      })
    })
  }

  /**
   * 判断是否是单选模式
   * @param {Object} mod - 配菜组
   * @returns {Boolean}
   */
  isRadioSelect(mod) {
    return isRadioSelectFn(mod)
  }

  /**
   * 这一组一次只能选一样吗（要画成单选那种）。
   * 与点击处理、置灰、数量步进用同一个判据，见 utils/sectionLimit.js。
   * @param {Object} mod - 配菜组
   * @returns {Boolean}
   */
  isSinglePickSection(mod) {
    return sectionIsSingleSelect(mod)
  }

  /**
   * 该配菜组是否展开（collapse === true 表示折叠，必选组恒展开）
   * @param {Object} mod - 配菜组
   * @returns {Boolean}
   */
  isSectionOpen(mod) {
    return isModSectionOpen(mod)
  }

  /**
   * 该配菜组是否禁止手动折叠（必选组）
   * @param {Object} mod - 配菜组
   * @returns {Boolean}
   */
  isSectionLocked(mod) {
    return isModSectionLocked(mod)
  }

  /**
   * 获取选项的显示数量
   * @param {Object} option - 选项
   * @returns {Number|String}
   */
  getOptionDisplayNumber(option) {
    return getOptionDisplayNumberFn(option)
  }

  /**
   * 判断选项是否可以增加数量
   * @param {Object} option - 选项
   * @param {Object} mod - 配菜组
   * @returns {Boolean}
   */
  canIncrease(option, mod) {
    return canIncreaseOption(option, mod)
  }

  /**
   * 处理选项点击事件
   * @param {Number} modIndex - 配菜组索引
   * @param {Number} optionIndex - 选项索引
   * @param {Object} mod - 配菜组
   * @param {Object} option - 选项
   */
  handleOptionClick(modIndex, optionIndex, mod, option) {
    // van-checkbox 事件顺序：@input (handleMultiCheckBoxInput) 先于 @click 触发。
    // @input 已经处理了勾选/取消勾选、number 初始化、以及 getCheckNum 验证。
    // @click 只需要处理"已选中状态下再次点击增加数量"的场景。
    //
    // Event order: @input fires before @click.
    // @input already handles check/uncheck, number init, and getCheckNum.
    // @click only handles "re-click on checked option to increase number".

    // 如果 @input 刚在本事件周期中处理了这个选项，跳过
    if (this._inputFiredForOption === `${modIndex}_${optionIndex}`) {
      this._inputFiredForOption = null
      return
    }

    // 仅处理：已选中 + 非单选 = 增加数量
    if (option.checked && !isRadioSelectFn(mod)) {
      if (canIncreaseOption(option, mod)) {
        this.increaseNumber(modIndex, optionIndex, mod, option)
      }
    }
  }

  /**
   * 增加选项数量
   * @param {Number} modIndex - 配菜组索引
   * @param {Number} optionIndex - 选项索引
   * @param {Object} mod - 配菜组
   * @param {Object} option - 选项
   */
  increaseNumber(modIndex, optionIndex, mod, option) {
    if (increaseOptionNumber(option, mod)) {
      this.validateAndUpdateMod(modIndex, mod)
      this.$forceUpdate()
    }
  }

  /**
   * 减少选项数量
   * @param {Number} modIndex - 配菜组索引
   * @param {Number} optionIndex - 选项索引
   * @param {Object} mod - 配菜组
   * @param {Object} option - 选项
   */
  decreaseNumber(modIndex, optionIndex, mod, option) {
    if (decreaseOptionNumber(option, mod)) {
      this.validateAndUpdateMod(modIndex, mod)
      this.$forceUpdate()
    }
  }

  /**
   * 验证并更新配菜组状态
   * @param {Number} modIndex - 配菜组索引
   * @param {Object} mod - 配菜组
   */
  validateAndUpdateMod(modIndex, mod) {
    const selectedTotal = calcSelectedTotal(mod.options)
    // `limitType` 归一化成 range / limit / exactly 三选一（见 utils/sectionLimit 的
    // `sectionLimitKind`）：**认不出来的值一律当 `exactly`**（owner 2026-08-10 裁定）。
    // 以前这条链直接比裸 `limitType`，没有 `else` —— 没写 limitType 的必选组
    // 一条校验都不跑，一样都不选照样加进购物车，屏幕上却写着「Required」。
    const limitKind = sectionLimitKind(mod)
    // 有效上限，唯一定义见 utils/sectionLimit.js（null = 没配上限）
    const sectionLimit = sectionMaxOption(mod)

    // 更新 disabled 状态
    if (sectionLimit !== null && selectedTotal >= sectionLimit) {
      mod.options.forEach((opt, idx) => {
        if (!opt.checked) {
          opt.disabled = true
        }
      })
    } else {
      mod.options.forEach((opt, idx) => {
        if (!opt.checked) {
          opt.disabled = false
        }
      })
    }

    // 验证状态
    if (mod.type === 'required') {
      if (limitKind === 'exactly') {
        // 有效上限就是「恰好选几样」的那个数。这一支在 `mod.type === 'required'` 里，
        // 而**必选**的 `exactly` 组永远给得出一个正整数（两个键都空就兜底 1，
        // 见 utils/sectionLimit.js），所以这里没有第二个来源可回落。
        // （可选的 `exactly` 组会是 NO_CAP，但它根本走不到这一支 —— 可选组不校验。）
        const targetCount = sectionLimit
        if (selectedTotal !== targetCount) {
          // 与另外两条红字路（点击后 / 加购整单校验）念同一句：以前这里是写死英文的
          // 模板串，法语/中文门店的组头念中文、步进这一步却念英文。数字取的是有效上限
          // （`sectionLimit` 就是上一行 `targetCount` 的来源），不是裸字段。
          mod.wrong = tParams('select_n_required', 'Select {n} (Required)', { n: sectionLimit })
          const i = this.passList.indexOf(modIndex)
          if (i !== -1) {
            this.passList.splice(i, 1)
          }
        } else {
          mod.wrong = false
          if (this.passList.indexOf(modIndex) === -1) {
            this.passList.push(modIndex)
          }
        }
      } else if (limitKind === 'range') {
        // 下限走契约（utils/sectionLimit 的 sectionLowerBound），与另外五道闸门同源。
        // 这一支在 `mod.type === 'required'` 里，所以下限**一定** >= 1（地板见契约）——
        // 以前读裸 `lowerBound`，说不出数时左半边整条短路，步进到 0 也照样放行。
        const minNum = sectionLowerBound(mod)
        if (selectedTotal < minNum || (sectionLimit !== null && selectedTotal > sectionLimit)) {
          // 与另外两条红字路走同一句实现（rangeCopy）：原值直出会念成
          // `Select between 2 and 0`，而且这句以前是写死英文、门店换语言也不变
          mod.wrong = rangeWrongCopy(mod)
          const i = this.passList.indexOf(modIndex)
          if (i !== -1) {
            this.passList.splice(i, 1)
          }
        } else {
          mod.wrong = false
          if (this.passList.indexOf(modIndex) === -1) {
            this.passList.push(modIndex)
          }
        }
      } else if (limitKind === 'limit') {
        if (selectedTotal < 1) {
          // 拦的是「一样都没选」，念「至少选 1 样」；以前念的 `Select up to {maxOption}`
          // 在 maxOption 没写时是 `Select up to  (Required)`，而且写死英文
          mod.wrong = limitWrongCopy()
          const i = this.passList.indexOf(modIndex)
          if (i !== -1) {
            this.passList.splice(i, 1)
          }
        } else {
          mod.wrong = false
          if (this.passList.indexOf(modIndex) === -1) {
            this.passList.push(modIndex)
          }
        }
      }
    }
  }
}

export default CollapseBox
</script>
